export const CompleteSignUp = {
  title: 'Complete seu cadastro',
  email: 'E-mail',
  birthdate: 'Data de Nascimento',
  phone: 'Celular',
  nickname: 'Apelido',
  complete: 'Completar'
};
